const web = {
  'abc-app' : 'hlL1SF7v',

  guangxiyidong : 'hlL1SFv2',
  jdbtpay       : 'hlL1SHE6',
  maycur        : 'hlL1SHFs',
  sa            : 'hlL239RV',
  cmb           : 'hlL239Wh',
  xczs          : 'hlL239Ya',
  caissa        : 'hlL239cN',
  jinjiang      : 'hlL239e4',
  inspur        : 'hlL239eh',
  cmblife       : 'hlL3N9pT',
  ehtsec        : 'hlL5RBcN',
  ems           : 'hlL78HLH',
  nbcb          : 'hlL7TFP6',
  vivoscreen    : 'hlL83FwD',
  opposcreen    : 'hlL83FwS',
  xiaomiscreen  : 'hlL83Fwj',
  huaweihag     : 'hlL8OGBp',
  spdbpay       : 'hlL96EHT',
  boc           : 'hlL9D9km',
  bcm           : 'hlL9SGKx',
  bcmcredit     : 'hlM2LA16',
  cebbank       : 'hlMAOBL7',
  'cebbank-mobile' : 'hlMCRACI',
  caixun        : 'hlLAE9YY',
  huaweiscreen  : 'hlM15Bbo',
  newhonor      : 'hlM4F9b7',
  'xiaoyi-hag'  : 'hlLC69mv',
  webank        : 'hlM5AEfL', //微众银行
  pingankoudai  : 'hlM5RA5u', //平安口袋银行
  'webapp-hbgj' : 'hlJ1NHKt', //航班管家h5
  'webapp-hbgj-quickapp': 'hlMBF9fR', //航班管家h5快应用
  hbkyysy       : 'hlMBF9fR',

  others : 'hlL1S9bT'
};

const quickApp = {
  xiaomi   : 'hlL1S9kS',
  huawei   : 'hlL1S9rF',
  vivo     : 'hlL1S9sB',
  oppo     : 'hlL1S9si',
  honor    : 'hlL1S9ti',
  gionee   : 'hlL1S9uL',
  lenovo   : 'hlL1S9ut',
  meizu    : 'hlL1SArM',
  motorola : 'hlL1SAs0',
  nubia    : 'hlL1SAsS',
  zte      : 'hlL1SAt1',
  oneplus  : 'hlL1SAtb',
  zuk      : 'hlL1SAuq',

  'huawei-sms' : 'hlL1SAvW',
  'oppo-sms'   : 'hlL1SAwf',
  'vivo-sms'   : 'hlL1SAxD',

  others : 'hlL1SAxh'
};

const native = {
  gtgj  : 'hlJ1MEoZ',
  hbgj  : 'hlL239tD',
  hlcar : 'hlL23A1B',
  hlsl  : 'hlL23A53',
  kssl  : 'hlL239cN'
};

const hlid = { web, quickApp, native };

export default hlid;



// WEBPACK FOOTER //
// ./src/DATA/hlid.js